"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Vue, Ref } from "vue-property-decorator";
import LoginLogsPage from "./logpages/LoginLogsPage.vue";
import ManageLogsPage from "./logpages/ManageLogsPage.vue";
import AccessLogsPage from "./logpages/AccessLogsPage.vue";
import RiskLogsPage from "./logpages/RiskLogsPage.vue";
let MemberLogs = class extends Vue {
  constructor() {
    super(...arguments);
    this.log_tabs = "";
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      this.log_tabs = "login_logs";
    });
  }
};
__decorateClass([
  PropSync("userId")
], MemberLogs.prototype, "user_id", 2);
__decorateClass([
  Ref("login_log_page")
], MemberLogs.prototype, "_login_log_page", 2);
MemberLogs = __decorateClass([
  Component({
    components: {
      LoginLogsPage,
      ManageLogsPage,
      AccessLogsPage,
      RiskLogsPage
    }
  })
], MemberLogs);
export {
  MemberLogs as default
};
